import type {Page} from "#magnolia-layer/types/magnolia-types";

export const getFirstTag = (page: Page): string | undefined => {
  if (!page) return undefined;
  const tags: string[] = page["mgnl:tags"];
  if (!tags) return undefined;
  if (tags.length === 0) return undefined;
  return tags[0];
};
